import type { Dayjs } from "dayjs";
import { businessDayOfMonth } from "@/helpers/time";

export const REPORT_DEADLINE_DAY = 10;

export const claimReportDeadline = (today: Dayjs): Dayjs =>
  businessDayOfMonth(today, REPORT_DEADLINE_DAY);

export const isClaimReportWindowOpen = (today: Dayjs): boolean =>
  !today.isAfter(claimReportDeadline(today), "day");

export const reportablePeriods = (
  today: Dayjs,
  enrolledAt: string
): string[] => {
  const enrolledPeriod = enrolledAt.slice(0, 7);

  return [today.subtract(1, "month"), today]
    .map((day) => day.format("YYYY-MM"))
    .filter((period) => period >= enrolledPeriod);
};

export const monthlyClaimAmount = (contract: {
  monthlyRent: number;
  adminFee?: number;
}): number => contract.monthlyRent + (contract.adminFee ?? 0);
